import { useState } from 'react';
import './styles/meetingEmbed.scss';

// Embeds a public Jitsi meeting inline (iframe) with an "open in a new window"
// fallback. Used by online lectures and by channels that have a meeting enabled.
// The URL is built server-side from the room name + configured Jitsi domain.
export default function MeetingEmbed({ url, label }: { url: string; label?: string }) {
    const [open, setOpen] = useState(false);

    if (!url) return null;

    if (!open) {
        return (
            <div className="meetingEmbed">
                <div className="joinRow">
                    <button className="joinMeet" onClick={() => setOpen(true)}>
                        <MeetIcon /> {label || "Připojit se ke schůzce"}
                    </button>
                    <a className="ghost" href={url} target="_blank" rel="noopener noreferrer">otevřít v novém okně</a>
                </div>
            </div>
        );
    }

    return (
        <div className="meetingEmbed open">
            <div className="frameWrap">
                <iframe
                    src={url}
                    title={label || "Online schůzka"}
                    allow="camera; microphone; fullscreen; display-capture; autoplay; clipboard-write"
                    allowFullScreen
                />
            </div>
            <div className="meetActions">
                <a className="ghost" href={url} target="_blank" rel="noopener noreferrer">Otevřít v novém okně</a>
                <span className="ghost" onClick={() => setOpen(false)}>Zavřít schůzku</span>
            </div>
        </div>
    );
}

function MeetIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="m22 8-6 4 6 4V8Z" />
            <rect x="2" y="6" width="14" height="12" rx="2" />
        </svg>
    );
}
